exports.EmployerType = {
    Employer: 1,
    Organisation: 2
}